import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {audios$} from './audio-spot';
import {UAudio} from '@/audio-contract/subscription';

export function subscribeAudioSpot() {
  audios$
    .pipe(map((audios: string[]): UAudio => ({type: 'audios', data: {audios}})))
    .subscribe((msg) => toUiMsg$.next(msg));
}
